/*@jsxRuntime automatic @jsxImportSource react*/
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
import {ToggleButtonUnchecked, ToggleButtonChecked, ToggleButtonDefault, ToggleButtonMultiselect, ToggleButtonVertical, ToggleButtonStatus, ToggleButtonStatusMessages, ToggleButtonDisabledGroup, ToggleButtonSuffix, ToggleButtonIconOnly} from 'Docs/uilib/components/toggle-button/Examples';
function _createMdxContent(props) {
  const _components = Object.assign({
    h2: "h2",
    h3: "h3",
    code: "code"
  }, _provideComponents(), props.components);
  return _jsxs(_Fragment, {
    children: [_jsx(_components.h2, {
      children: "Demos"
    }), "\n", _jsx(_components.h3, {
      children: "Unchecked ToggleButton"
    }), "\n", _jsx(ToggleButtonUnchecked, {}), "\n", _jsx(_components.h3, {
      children: "Checked ToggleButton"
    }), "\n", _jsx(ToggleButtonChecked, {}), "\n", _jsx(_components.h3, {
      children: "Default ToggleButton group"
    }), "\n", _jsx(ToggleButtonDefault, {}), "\n", _jsx(_components.h3, {
      children: "Multi-select ToggleButton group"
    }), "\n", _jsx(ToggleButtonMultiselect, {}), "\n", _jsxs(_components.h3, {
      children: ["Vertical aligned ToggleButton group with ", _jsx(_components.code, {
        children: "checkbox"
      }), " variant and ", _jsx(_components.code, {
        children: "multiselect"
      })]
    }), "\n", _jsx(ToggleButtonVertical, {}), "\n", _jsxs(_components.h3, {
      children: ["ToggleButton group as ", _jsx(_components.code, {
        children: "multiselect"
      }), " with a status message"]
    }), "\n", _jsx(ToggleButtonStatus, {}), "\n", _jsxs(_components.h3, {
      children: ["ToggleButton with status messages and a group variant as ", _jsx(_components.code, {
        children: "radio"
      })]
    }), "\n", _jsx(ToggleButtonStatusMessages, {}), "\n", _jsx(_components.h3, {
      children: "Disabled ToggleButton group"
    }), "\n", _jsx(ToggleButtonDisabledGroup, {}), "\n", _jsx(_components.h3, {
      children: "ToggleButtons with a suffix"
    }), "\n", _jsx(ToggleButtonSuffix, {}), "\n", _jsx(_components.h3, {
      children: "ToggleButtons with icons only"
    }), "\n", _jsx(ToggleButtonIconOnly, {})]
  });
}
function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = Object.assign({}, _provideComponents(), props.components);
  return MDXLayout ? _jsx(MDXLayout, Object.assign({}, props, {
    children: _jsx(_createMdxContent, props)
  })) : _createMdxContent(props);
}
export default MDXContent;
